export class ArquivoSearch{
    id: number;
    idEmpresa: number;
    createdAt: Date;
    idUsuarioCreated: number;
    nomeUsuarioCreated: string;
    avatarURLUsuarioCreated: string;
    idTipoArquivo: number;
    url: string;
    extensao: number;
    nome: string;
    descricao: string;

    // Referência
    referencia: number;

    // Pedido
    pedidoPendenteExpedicao: boolean;

    // Dados temporários de upload
    selected: boolean;
    idUpload?: number
}

export class ArquivoSearchTotal {
    quantidade: number;
}
